import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=0a447e7e&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a447e7e')) {
      api.createRecord('0a447e7e', component.options)
    } else {
      api.reload('0a447e7e', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=0a447e7e&", function () {
      api.rerender('0a447e7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2y614QLCoIRte/JS/comp/childrenage.vue"
export default component.exports